export enum enumMarineInsuranceCommodity {
  GENERAL = 24,
  ELECTRONICS = 25,
  VEHICLES = 26,
  MOBILE_PHONES = 27,
  FRAGILES = 42,
  BOATS_AND_YACHTS = 28,
}
